if (!customElements.get("pdp-tabs")) {
  customElements.define(
    "pdp-tabs",
    class PDPTabs extends HTMLElement {
      constructor() {
        super();
        this.toggles = Array.from(
          this.querySelectorAll('[class*="pdp-tabs__toggle-"]')
        );
        this.contents = Array.from(
          this.querySelectorAll('[class*="pdp-tab-"]')
        );
      }

      connectedCallback() {
        this.addEventListeners();
      }

      addEventListeners() {
        if (this.toggles) {
          this.toggles.forEach((toggle) => {
            toggle.addEventListener("click", () => {
              this.handleTabChange(toggle);
            });
          });
        }
      }

      handleTabChange(toggle) {        
        const match = toggle.className.match(/pdp-tabs__toggle-(\d+)/); 

        if (!match) return;

        const index = match[1];

        this.toggles.forEach((tog) => {
          tog.classList.remove("pdp-tabs__toggle-active");
        });
        this.contents.forEach((tab) => {
          tab.style.display = "none";
        });

        toggle.classList.add("pdp-tabs__toggle-active");

        const targetTab = this.querySelector(`.pdp-tab-${index}`);
        if (targetTab) {
          targetTab.style.display = "block";
        }

        toggle.scrollIntoView({
          behavior: "smooth",
          inline: "center", //center horizontally
          block: "nearest",
        });
      }
    }
  );
}
